const crumbOf = (loaderData: unknown) =>
  typeof loaderData === "object" && loaderData !== null && "crumb" in loaderData && typeof loaderData.crumb === "string"
    ? loaderData.crumb
    : null;

/**
 * The breadcrumb trail: one step per route that names itself with `{ crumb }` from its loader, so
 * every step is translated and links somewhere real. A part of the URL no route answers (`/pay` in
 * `/pay/$orderId`) is no step at all. A layout and its index share an address, and count once.
 */
export const crumbTrail = (matches: readonly { pathname: string; loaderData?: unknown }[]) => {
  const trail = new Map<string, string>();
  for (const match of matches) {
    const crumb = crumbOf(match.loaderData);
    if (crumb !== null) trail.set(match.pathname.replace(/\/$/, ""), crumb);
  }
  return [...trail].map(([to, label]) => ({ to, label }));
};
